import { Reveal, Eyebrow } from "./Reveal";
import { WHY_US } from "../data/content";

export const WhyUs = () => (
    <section id="warum-wir" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto" data-testid="why-us-section">
        <Reveal>
            <Eyebrow num="03" label="Warum Julians Gartenservice" />
            <h2 className="font-display font-semibold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.12] max-w-2xl">
                Darauf können Sie sich verlassen.
            </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-hairline rounded-3xl overflow-hidden border border-hairline">
            {WHY_US.map((w, i) => (
                <Reveal key={w.num} delay={i * 0.08} className="h-full">
                    <div
                        data-testid={`why-us-chapter-${w.num}`}
                        className="h-full bg-white p-8 flex flex-col transition-colors duration-300 hover:bg-leaf-light/50"
                    >
                        <span className="font-mono text-4xl font-semibold text-leaf/30">{w.num}</span>
                        <h3 className="mt-6 font-display font-semibold tracking-tight text-ink text-xl">{w.title}</h3>
                        <p className="mt-3 text-sm text-shade leading-relaxed flex-1">{w.desc}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
